import { SelectOption } from "types";

const UNITS_ARRAY: SelectOption<string>[] = [
  { label: "mcg/kg", value: "mcg/kg" },
  { label: "mg/kg", value: "mg/kg" },
  { label: "g/kg", value: "g/kg" },
  { label: "mL/kg", value: "mL/kg" },
  { label: "mg", value: "mg" },
  { label: "g", value: "g" },
  { label: "mcg", value: "mcg" },
  { label: "mL", value: "mL" },
  { label: "L", value: "L" },
  { label: "units", value: "units" },
  { label: "mEq", value: "mEq" },
  { label: "iu", value: "iu" },
  { label: "oz", value: "oz" },
  { label: "drops", value: "drops" },
  { label: "spray", value: "spray" },
  { label: "package", value: "package" },
  { label: "units/kg", value: "units/kg" },
  { label: "units/hr", value: "units/hr" },
  { label: "mL/hr", value: "mL/hr" },
  { label: "mg/hr", value: "mg/hr" },
];

const CONCENTRATION_DOSE_UNITS: SelectOption<string>[] = [
  { label: "mg", value: "mg" },
  { label: "g", value: "g" },
  { label: "mcg", value: "mcg" },
  { label: "units", value: "units" },
  { label: "mEq", value: "mEq" },
  { label: "iu", value: "iu" },
  { label: "mL", value: "mL" },
  { label: "L", value: "L" },
];

const VOLUME_UNITS: SelectOption<string>[] = [
  { label: "mL", value: "mL" },
  { label: "L", value: "L" },
  { label: "mcg", value: "mcg" },
  { label: "mg", value: "mg" },
  { label: "g", value: "g" },
  { label: "kg", value: "kg" },
  { label: "units", value: "units" },
  { label: "mEq", value: "mEq" },
  { label: "iu", value: "iu" },
  { label: "minutes", value: "minutes" },
];

const BACKEND_INT32_MAX = 2_147_483_647;
const MAX_SCHEDULE_REPETITIONS = 100;

export {
  UNITS_ARRAY,
  CONCENTRATION_DOSE_UNITS,
  VOLUME_UNITS,
  BACKEND_INT32_MAX,
  MAX_SCHEDULE_REPETITIONS,
};
